export const SET_INSTITUTION_USER_TEST_TIMER = '@institution-user-test/start-timer';

export const setInstitutionUserTestTimer = () => ({
  type: SET_INSTITUTION_USER_TEST_TIMER,
});
